module.exports = __webpack_public_path__ + "img/linkedin-in-brands.1e01f0c0.svg";